import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ViaCepResponse } from '../../responses/integration/via-cep.response';

@Injectable({
  providedIn: 'root'
})
export class ViaCepService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public getAddressByCep(cep: string): Observable<ViaCepResponse> {
    
    let uri = `ViaCep/cep/${cep}`
    
    return this.httpClient.get<ViaCepResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiIntegration) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}